import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'

import PatientDialogContainer from '../dialogs/patient'
import PatientSearch from '../../components/patient/PatientSelector/search'
import * as patientSelectors from '../../redux/patients/selectors'
import * as patientActions from '../../redux/patients/actions'
import * as appointmentActions from '../../redux/appointments/actions'
import * as dialogActions from '../../redux/dialogs/actions'
import * as insuranceCompanySelectors from '../../redux/insuranceCompanies/selectors'
import * as insuranceCompanyActions from '../../redux/insuranceCompanies/actions'
import { patientRequiresCopay } from '../../utils/copaySessions'

const PatientSelectorContainer = ({ handleOpenPatientDialog, dispatchGetPatientById, dispatchGetAppointmentsByPatient, dispatchGetAllPatients, dispatchGetAllInsuranceCompanies, dispatchOpenCopaidPaymentDialog, dispatchGetCopayBalances, defaultPatientId, dispatchOpenPatientDialog, handleChange, patients, insuranceCompanies, showCopayBalance = false, ...rest }) => {

  const [optionSelected, setOptionSelected] = React.useState(null)

  // Fetch all patients
  React.useEffect(() => {
    dispatchGetAllPatients()
    dispatchGetAllInsuranceCompanies()
  }, [])

  React.useEffect(() => {
    // THIS IS ONLY FOR SETTING THE DEFAULT OPTION
    if(!optionSelected || optionSelected.value !== defaultPatientId) {
      const patient = searchPatientById(defaultPatientId)
      if(patient) {
        setOptionSelected({ label: patient.get('fullName'), value: patient.get('_id')})
      }
    }
  }, [defaultPatientId, patients])

  React.useEffect(() => {
    if (!showCopayBalance || !optionSelected) return
    const patient = searchPatientById(optionSelected.value)
    if (!patient || !patientRequiresCopay(patient, insuranceCompanies)) return
    if (!patient.has('copaidSessionsBalance')) {
      dispatchGetCopayBalances([optionSelected.value])
    }
  }, [optionSelected, showCopayBalance, patients, insuranceCompanies])

  const searchPatientById = (id) => patients.valueSeq().find(patient => patient.get('_id') === id)

  const openNewPatientDialog = () => {
    dispatchOpenPatientDialog()
  }

  const openPatientDialog = () => {
    if(optionSelected) {
      const patientId = optionSelected.value
      dispatchGetAppointmentsByPatient(patientId)

      const patient = searchPatientById(patientId)
      if(patient) {
        dispatchOpenPatientDialog({ patient })
      }
    }
  }

  const onChange = (optionSelected) => {
    setOptionSelected(optionSelected)
    if (!optionSelected) {
      handleChange({ target: { value: '', name: 'patient' } }, null)
      return
    }
    const patient = searchPatientById(optionSelected.value)
    handleChange({ target: { value: optionSelected.value, name: 'patient' }}, patient)
  }

  const handleCopayChipClick = (patientId) => {
    if (patientId) {
      dispatchOpenCopaidPaymentDialog({ patientId })
    }
  }

  const patient = searchPatientById(defaultPatientId)
  return (
    <React.Fragment>
      <PatientSearch
        defaultValue={patient ? ({ value: patient.get('_id'), label:  patient.get('fullName') }) : null}
        value={optionSelected}
        handleChange={onChange}
        patients={patients}
        insuranceCompanies={insuranceCompanies}
        showCopayBalance={showCopayBalance}
        onCopayChipClick={handleCopayChipClick}

        openNewPatientDialog={openNewPatientDialog}
        openPatientDialog={openPatientDialog}

        {...rest}
      />
      <PatientDialogContainer />
    </React.Fragment>
  )
}

PatientSelectorContainer.propTypes = {
  patients: ImmutablePropTypes.map,
  defaultPatientId: PropTypes.string,
  showCopayBalance: PropTypes.bool,
  dispatchGetPatientById: PropTypes.func.isRequired,
  dispatchGetAllPatients: PropTypes.func.isRequired,
  handleOpenPatientDialog: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  patients: patientSelectors.getAll(state),
  insuranceCompanies: insuranceCompanySelectors.getAll(state),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGetPatientById: (id) => dispatch(patientActions.getById(id)),
  dispatchGetAllPatients: () => dispatch(patientActions.getAll()),
  dispatchGetAllInsuranceCompanies: () => dispatch(insuranceCompanyActions.getAll()),
  dispatchGetAppointmentsByPatient: patientId => dispatch(appointmentActions.getAllByPatient(patientId)),
  dispatchOpenPatientDialog: (data) => dispatch(dialogActions.open('patient', data)),
  dispatchOpenCopaidPaymentDialog: (data) => dispatch(dialogActions.open('copaidPayment', data)),
  dispatchGetCopayBalances: (ids) => dispatch(patientActions.getCopayBalances(ids)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PatientSelectorContainer)
